import { UserLoginRequest, UserChangePasswordRequest } from "../../models/user";
import { callApi } from "./utils";

export class LoginService {

    userLogin = async (request: UserLoginRequest) => {
        try {              
            const response = await callApi(`Admin/Login`, 'POST', request);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error();
        }
    }

    userChangePassword = async (request: UserChangePasswordRequest) => {
        try {              
            const response = await callApi(`Admin/ChangePassword`, 'POST', request);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error();
        }
    }  
}